

///Here we handle default actions
const dialog               = require ('../dialog/dialog')
const quickform            = require ('../quickform/quickform')
const quickformForm        = require ('../quickform/quickform-form')

var scrimQuickform


//insert and select the Quickform on the body and select all the inputs
//and save on htmlQf all the importants documents
export function HTMLselect(entity, id, source ,quickformHTML, form, formCopy, htmlQf){ 

   
    scrimQuickform  = document.getElementById('scrim_quickform')

    loadQuickform(quickformHTML)

    if(form != undefined){
        //select all the input html to the form
        for(let i=0 ; i < form.length ; i++){
            let elem = document.getElementById(form[i].id)
            form[i].html     = elem
            formCopy[i].html = elem

        }
        
    }


    htmlQf.entity        =  entity
    htmlQf.source        =  source
    htmlQf.form          =  form
    htmlQf.formCopy      =  formCopy
    htmlQf.quickformHTML =  document.getElementById(id)

}/*init*/

//decide if we insert the Quickform on the page or in the body
//somes Quickform aren't insert in page as edit profield
function loadQuickform(quickformHTML){  // console.log(`Quickform Show>`, ); 

// /************************red - Remove this from here*/
//         const body = document.body
//         body.insertAdjacentHTML("beforeend", QuickformHTML)   
// /************************red*/

    const body = document.body
    body.insertAdjacentHTML("beforeend", quickformHTML)           


   // console.log('entityPagexxx>', entityPage)

}


export function show(detail){// console.log('quickform show>', htmlQf)



	detail.html.classList.add('quickform-show')
	scrimQuickform.classList.add('scrim-show')

}


export function hide(detail){// console.log('quickform show>', htmlQf)


	detail.html.classList.add('quickform-hide')
	scrimQuickform.classList.add('scrim-hide')


	remove(()=>{
		detail.html.classList.remove('quickform-hide');
		detail.html.classList.remove('quickform-show');

  		scrimQuickform.classList.remove('scrim-show')
  		scrimQuickform.classList.remove('scrim-hide')
	})

}



function remove(callback){
	setTimeout(()=>{
		callback()
	}, 300)
}




export function prepareAdd(detail,htmlQf){ //console.log('prepareAdd>1') 

    //remove the view/edit from the page
    htmlQf.quickformHTML.classList.remove('mode-view')
    htmlQf.quickformHTML.classList.remove('mode-edit')
    htmlQf.quickformHTML.classList.add('mode-add')

    //clean htmlprepareAdd
    quickformForm.clean(htmlQf)
    
    //clean the form obj value
    quickformForm.cleanFromValues(htmlQf)

    //move the entity page, or mainPage before start
    quickform.start( {act:"show", html: htmlQf.quickformHTML } )

}


export function prepareView(form, detail){ //console.log('prepareViewx', detail.id)

    const quickformParent =  document.getElementById(detail.id)

    //remove the view from the page
    quickformParent.classList.add('mode-view')
    quickformParent.classList.remove('mode-edit')
    quickformParent.classList.remove('mode-add')

}/**/


